"use client"

import { useEffect, useState } from "react"
import Script from "next/script"
import { synchronizeGoogleConsent } from "../../lib/analytics/google-consent"
import {
  markSignupTagReady,
  mountAccountSignupTracking,
} from "../../lib/analytics/account-signup"

const ga4Id = /^G-[A-Z0-9]+$/i.test(process.env.NEXT_PUBLIC_GA4_ID ?? "")
  ? process.env.NEXT_PUBLIC_GA4_ID
  : null
const googleAdsId =
  process.env.NODE_ENV === "production" ? "AW-18023474798" : null

export const GoogleTags = () => {
  const [permissions, setPermissions] = useState({
    analytics: false,
    advertising: false,
  })
  const [safePage, setSafePage] = useState(false)
  useEffect(() => {
    const synchronize = () => {
      const allowed = synchronizeGoogleConsent()
      setPermissions((previous) =>
        previous.analytics === allowed.analytics &&
        previous.advertising === allowed.advertising
          ? previous
          : allowed
      )
      setSafePage(window.location.search === "" && window.location.hash === "")
    }
    synchronize()
    const stopTracking = mountAccountSignupTracking()
    const interval = window.setInterval(synchronize, 1000)
    window.addEventListener("focus", synchronize)
    return () => {
      stopTracking()
      window.clearInterval(interval)
      window.removeEventListener("focus", synchronize)
    }
  }, [])

  const onReady = () => {
    markSignupTagReady()
  }
  if (!safePage) return null
  return (
    <>
      {permissions.analytics && ga4Id && (
        <>
          <Script
            src={`https://www.googletagmanager.com/gtag/js?id=${ga4Id}`}
            onReady={onReady}
            strategy="afterInteractive"
          />
          <Script id="ga4-init" strategy="afterInteractive">
            {`window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}gtag('js',new Date());gtag('config','${ga4Id}',{page_location:'https://console.seam.co/',page_referrer:'',page_title:'Seam Console',allow_google_signals:false,allow_ad_personalization_signals:false});`}
          </Script>
        </>
      )}
      {permissions.advertising && googleAdsId && (
        <>
          <Script
            src={`https://www.googletagmanager.com/gtag/js?id=${googleAdsId}`}
            onReady={onReady}
            strategy="afterInteractive"
          />
          <Script id="google-ads-init" strategy="afterInteractive">
            {`window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}gtag('js',new Date());gtag('config','${googleAdsId}',{send_page_view:false,page_location:'https://console.seam.co/',page_referrer:'',allow_google_signals:false,allow_ad_personalization_signals:false});`}
          </Script>
        </>
      )}
    </>
  )
}
